import { render, staticRenderFns } from "./Unblock-User-Prompt.vue?vue&type=template&id=77357eb4&scoped=true&"
import script from "./Unblock-User-Prompt.vue?vue&type=script&lang=js&"
export * from "./Unblock-User-Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Unblock-User-Prompt.vue?vue&type=style&index=0&id=77357eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77357eb4",
  null
  
)

export default component.exports